import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { loaderSlice } from "./slices/loaderSlice";
import { loginQuery } from "./services/loginRegisterQuery";
import { snackbarSlice } from "./slices/snackbarSlice";
import { commonSlice } from "./slices/commonSlice";
import { rolesQuery } from "./services/rolesQuery";
import { permissionsQuery } from "./services/permissionsQuery";
import { usersSlice } from "./slices/usersSlice";
import { usersQuery } from "./services/usersQuery";
import { studiesQuery } from "./services/studiesQuery";
import { sitesQuery } from "./services/sitesQuery";
import { codelistQuery } from "./services/codelistQuery";
import { studiesSlice } from "./slices/studiesSlice";
import { centralLabQuery } from "./services/centralLabQuery";
import { vendorsQuery } from "./services/vendorsQuery";
import { vendorSlice } from "./slices/vendorSlice";
import { auditSlice } from "./slices/auditSlice";
import { protocolQuery } from "./services/protocolQuery";
import { passcodeQuery } from "./services/passcodeQuery";
import { auditQuery } from "./services/auditQuery";
import { connectorQuery } from "./services/connectorQuery";
import { entityQuery } from "./services/entityQuery";
import { componentQuery } from "./services/componentsQuery";
import { transformationQuery } from "./services/transformationQuery";

export const store = configureStore({
  reducer: {
    loaderSlice: loaderSlice.reducer,
    snackbarSlice: snackbarSlice.reducer,
    commonSlice: commonSlice.reducer,
    usersSlice: usersSlice.reducer,
    studiesSlice: studiesSlice.reducer,
    vendorSlice: vendorSlice.reducer,
    auditSlice: auditSlice.reducer,
    [loginQuery.reducerPath]: loginQuery.reducer,
    [rolesQuery.reducerPath]: rolesQuery.reducer,
    [permissionsQuery.reducerPath]: permissionsQuery.reducer,
    [usersQuery.reducerPath]: usersQuery.reducer,
    [studiesQuery.reducerPath]: studiesQuery.reducer,
    [sitesQuery.reducerPath]: sitesQuery.reducer,
    [codelistQuery.reducerPath]: codelistQuery.reducer,
    [centralLabQuery.reducerPath]: centralLabQuery.reducer,
    [vendorsQuery.reducerPath]: vendorsQuery.reducer,
    [protocolQuery.reducerPath]: protocolQuery.reducer,
    [passcodeQuery.reducerPath]: passcodeQuery.reducer,
    [auditQuery.reducerPath]: auditQuery.reducer,
    [connectorQuery.reducerPath]: connectorQuery.reducer,
    [entityQuery.reducerPath]: entityQuery.reducer,
    [componentQuery.reducerPath]: componentQuery.reducer,
    [transformationQuery.reducerPath]: transformationQuery.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      loginQuery.middleware,
      rolesQuery.middleware,
      permissionsQuery.middleware,
      usersQuery.middleware,
      studiesQuery.middleware,
      sitesQuery.middleware,
      codelistQuery.middleware,
      centralLabQuery.middleware,
      vendorsQuery.middleware,
      protocolQuery.middleware,
      passcodeQuery.middleware,
      auditQuery.middleware,
      connectorQuery.middleware,
      entityQuery.middleware,
      componentQuery.middleware,
      transformationQuery.middleware
    ),
});

export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof store.getState>;
export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
